<template>
    <div class="field grid">
        <label for="Order_No" class="col-4 font-bold">{{$t("order_no")}}</label>
        <span class="col-1 md-1">:</span>
        <div class="col-7 md-7">
            <span>{{data.Order_No}}</span>
        </div>
        <Divider class="m-0" />
    </div>
    <div class="field grid">
        <label for="SAP_No" class="col-4 font-bold">{{$t("sap_no")}}</label>
        <span class="col-1 md-1">:</span>
        <div class="col-7 md-7">
            <span class="pre">{{data.SAP_No}}</span>
        </div>
        <Divider class="m-0" />
    </div>
    <div class="field grid">
        <label for="Product_Category" class="col-4 font-bold">{{$t("product_category")}}</label>
        <span class="col-1 md-1">:</span>
        <div class="col-7 md-7">
            <span>{{data.Business_Segment_Name}}</span>
        </div>
        <Divider class="m-0" />
    </div>
    <div class="field grid">
        <label for="Warehouse" class="col-4 font-bold">{{$t('warehouse')}}</label>
        <span class="col-1 md-1">:</span>
        <div class="col-7 md-7">
            <span>{{data.Warehouse_Name}}</span>
        </div>
        <Divider class="m-0" />
    </div>
    <div class="field grid">
        <label for="Warehouse_Location" class="col-4 font-bold">{{$t('warehouse_location')}}</label>
        <span class="col-1 md-1">:</span>
        <div class="col-7 md-7">
            <span>{{data.warehouse_location_name}}</span>
        </div>
        <Divider class="m-0" />
    </div>
    <div class="field grid">
        <label for="Incoterm2" class="col-4 font-bold">{{$t('incoterm2')}}</label>
        <span class="col-1 md-1">:</span>
        <div class="col-7 md-7">
            <span class="pre">{{data.Incoterm2}}</span>
        </div>
        <Divider class="m-0" />
    </div>
    <div class="field grid">
        <label for="Customer_Vendor" class="col-4 font-bold">{{$t('customer_vendor')}}</label>
        <span class="col-1 md-1 ">:</span>
        <div class="col-7 md-7">
            <span class="pre-line">{{data.Customer_Vendor_Name}}</span>
        </div>
        <Divider class="m-0" />
    </div>
    <div class="field grid">
        <label for="Address" class="col-4 font-bold">{{$t("address")}}</label>
        <span class="col-1 md-1 ">:</span>
        <div class="col-7 md-7">
            <span class="pre-line">{{data.Delivery_Address ? data.Delivery_Address : data.Customer_Vendor_Address}}</span>
        </div>
        <Divider class="m-0" />
    </div>
    <div class="field grid">
        <label for="Shipment_Type" class="col-4 font-bold">{{$t("shipment_type")}}</label>
        <span class="col-1 md-1 ">:</span>
        <div class="col-7 md-7">
            <span>{{data.shipment_type_name}}</span>
        </div>
        <Divider class="m-0" />
    </div>
     <div class="field grid">
        <label for="Transporter_Notes" class="col-4 font-bold">{{$t("transporter_notes")}}</label>
        <span class="col-1 md-1 ">:</span>
        <div class="col-7 md-7">
            <span>{{data.Transporter_Notes}}</span>
        </div>
        <Divider class="m-0" />
    </div>
</template>
<script>

export default {
    props:{
        data:null
    },
    computed:{
    }
}
</script>